import { Pipe, PipeTransform } from '@angular/core';

import { isEmpty, isNil } from 'lodash-es';

import { WalkingFarmLeadStatusEnum, WalkingFarmLeadStatusLabelEnum } from '../../enums/walking-farm';

@Pipe({
  name: 'redLeadStatus',
  standalone: false
})
export class LeadStatusPipe implements PipeTransform {
  transform(value: string | undefined) {
    let result = '';
    if (!isNil(value)) {
      switch (value?.toLowerCase()) {
        case WalkingFarmLeadStatusEnum.Lead:
          result = WalkingFarmLeadStatusLabelEnum.Lead;
          break;
        case WalkingFarmLeadStatusEnum.NotContacted:
          result = WalkingFarmLeadStatusLabelEnum.NotContacted;
          break;
        case WalkingFarmLeadStatusEnum.NotHome:
          result = WalkingFarmLeadStatusLabelEnum.NotHome;
          break;
        case WalkingFarmLeadStatusEnum.NotInterested:
          result = WalkingFarmLeadStatusLabelEnum.NotInterested;
          break;
        case WalkingFarmLeadStatusEnum.OnMarket:
          result = WalkingFarmLeadStatusLabelEnum.OnMarket;
          break;
        case WalkingFarmLeadStatusEnum.Prospect:
          result = WalkingFarmLeadStatusLabelEnum.Prospect;
          break;
        default:
          result = WalkingFarmLeadStatusLabelEnum.Default;
          break;
      }
    }

    if (isEmpty(result)) {
      result = '--';
    }

    return result;
  }
}
